import PropTypes from "prop-types";
import { alpha } from "@mui/system/colorManipulator";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-regular-svg-icons";
import { faDesktop } from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AccountButton } from "./account-button/account-button";
import { NotificationsButton } from "./notifications-button/notifications-button";
import { DarkModeButton } from "./dark-mode-button/dark-mode-button";
import { HelpButton } from "./help-button/help-button";
import { LanguageSwitch } from "./language-switch/language-switch";

import { COMPONENTS } from "@theme/admin";

const NavDivider = () => (
  <Box
    sx={{
      width: "1px",
      height: "28px",
      bgcolor: (t) => alpha(t.palette.text.primary, 0.3),
      mx: 1,
      alignSelf: "center",
    }}
  />
);

export const TopNav = (props) => {
  const { onMobileNavOpen, ...other } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      component="header"
      sx={{
        backdropFilter: "blur(6px)",
        backgroundColor: (theme) =>
          alpha(theme.palette.background.default, 0.8),
        position: "sticky",
        left: {
          lg: `${COMPONENTS.SIDE_NAV_WIDTH}px`,
        },
        top: 0,
        width: {
          lg: `calc(100% - ${COMPONENTS.SIDE_NAV_WIDTH}px)`,
        },
        zIndex: (theme) => theme.zIndex.appBar,
      }}
      {...other}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: COMPONENTS.TOP_NAV_HEIGHT,
          px: 2,
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
          }}
        >
          {!lgUp && (
            <IconButton onClick={onMobileNavOpen}>
              <SvgIcon>
                <FontAwesomeIcon icon={faBars} />
              </SvgIcon>
            </IconButton>
          )}
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
          }}
        >
          <LanguageSwitch />
          <DarkModeButton />
          <HelpButton />

          <NavDivider />

          <NotificationsButton />
          <Tooltip title={t("common.goToHome")}>
            <IconButton onClick={() => navigate("/home")}>
              <SvgIcon>
                <FontAwesomeIcon icon={faDesktop} />
              </SvgIcon>
            </IconButton>
          </Tooltip>

          <AccountButton />
        </Stack>
      </Stack>
    </Box>
  );
};

TopNav.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
